import React, { useContext, useEffect, useState } from "react";
import {
  calcPlanIconColor,
  checkCreateRoomPermission,
  isMobile,
} from "../../utils/utils";
import {
  createRoomByAI,
  generateInstantCallUrl,
} from "../../services/rooomService";
import { frontEndURL } from "../../utils/axios";
import { StoreContext } from "../../Context/StoreContext";
import { showLoginModal } from "../../actions/uiModalActions";
import CreatedLinkModal from "../CreatedLinkModal";
import Loader from "../../VibehutUI/Loader";
import CreateRoom from "../rooms/CreateRoom";
import ConfirmationModal from "../../VibehutUI/ConfirmationModal";
import { openPlanModal } from "../../actions/profileModalActions";
import DoubleStar from "../../VibehutUI/Icons/DoubleStar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import globals from "../../globals";

const HomeHeader = () => {
  const defaultPlaceholder = [
    "A room called English Learning for Students",
    "Make a video call room for my FieldHouse Creative agency",
    "A token gated NFT community room for the LightApes",
    "My virtual language learning room called Global Language",
    "Create a paid video call room for my @GoodFoodies TikTok followers",
  ];
  const { state, dispatch } = useContext(StoreContext);
  const {
    auth,
    room: { myRoomsCount },
    role,
  } = state;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [roomUUID, setRoomUUID] = useState(undefined);
  const [isInstanceCall, setIsInstanceCall] = useState(undefined);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [roomName, setRoomName] = useState("");
  const [currentPlaceHolderIndex, setCurrentPlaceHolderIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [saleEndTime, setSaleEndTime] = useState(
    new Date("2023-11-27T23:59:00"),
  );
  const [saleCounter, setSaleCounter] = useState("");

  useEffect(() => {
    const updateTimer = () => {
      const currentTime = new Date();
      const timeDifference = saleEndTime - currentTime;

      if (timeDifference <= 0) {
        return;
      }
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60),
      );
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      setSaleCounter(`${days}D ${hours}H ${minutes}M ${seconds}S`);
    };
    const timerInterval = setInterval(updateTimer, 1000);

    return () => clearInterval(timerInterval);
  }, [saleEndTime]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentPlaceHolderIndex(
        (prevIndex) => (prevIndex + 1) % defaultPlaceholder.length,
      );
    }, 8000);
    return () => clearInterval(intervalId);
  }, []);

  const handleCreateRoom = async () => {
    if (!auth?.user) {
      return showLoginModal(dispatch);
    }
    if (myRoomsCount === undefined) {
      return;
    }
    if (checkCreateRoomPermission(role, myRoomsCount, auth?.user)) {
      setIsOpen(true);
    } else {
      setOpenConfirmationModal(true);
    }
  };

  const copyInstantCallLink = async () => {
    try {
      setIsInstanceCall("copy");
      if (!auth?.user) {
        setIsInstanceCall(undefined);
        return showLoginModal(dispatch);
      }
      const res = await generateInstantCallUrl(auth.user.token);
      const url = res.data;
      const uuid = url.split(`${frontEndURL}/call?v=`)[1];
      setRoomUUID(uuid);
      setIsInstanceCall(undefined);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreateRoomByAI = async () => {
    if (!roomName) return;
    if (!auth?.user) {
      return showLoginModal(dispatch);
    }
    if (!checkCreateRoomPermission(role, myRoomsCount, auth?.user)) {
      setOpenConfirmationModal(true);
      return;
    }
    try {
      setIsLoading(true);
      const room = (
        await createRoomByAI(
          {
            name: roomName,
          },
          auth?.user?.token,
        )
      ).data;
      if (room) {
        if (room?.slug) {
          return history.push(room.slug);
        }
        history.push(`rooms/${room._id}`);
      }
    } catch (err) {
      globals.showModal(
        "Oops!",
        <>
          <div className="bg-white text-gray-600 dark:text-gray-300 dark:bg-navyGray p-4 relative">
            <p className="text-lg">Something went wrong, please try again</p>
          </div>
        </>,
      );
    } finally {
      setIsLoading(false);
      setRoomName("");
    }
  };

  const setFormattedContent = (value) => {
    const text = value.slice(0, 4000);
    setRoomName(text);
  };

  return (
    <>
      <div className="w-full flex flex-col justify-center items-center mt-14 px-6 sm:pb-6">
        <div className="pt-4 ">
          <p className="font-bold text-2xl  sm:text-32px  text-center text-darkNight  dark:text-frescoWhite">
            Where Business and Community
          </p>
          <p className="font-bold text-2xl  sm:text-32px  text-center text-darkNight  dark:text-frescoWhite mt-1">
            Video Calls Happen.
          </p>

          <div className="mt-5 relative">
            <input
              type="text"
              className={`placeholder:font-normal placeholder:animate-pulse focus:outline-none
              shadow-drop border-none py-4 px-4 rounded-xl w-330pxl xs:w-[450px] sm:w-[580px] h-[60px] ${
                isLoading ? "pr-32 sm:pr-40" : "pr-24 sm:pr-56"
              }  `}
              value={roomName}
              placeholder={`${defaultPlaceholder[currentPlaceHolderIndex]}`}
              onChange={(event) => setFormattedContent(event.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleCreateRoomByAI();
                }
              }}
            />
            <button
              disabled={roomName?.trim() === "" || isLoading}
              className="px-1 py-1 bg-gradient-btn-border text-white rounded-3xl absolute right-1 sm:right-2 top-2 sm:top-1.5 "
              onClick={handleCreateRoomByAI}
            >
              <div className="bg-gradient-btn flex align-center items-center  rounded-3xl justify-center px-1.5 sm:px-4 py-2">
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <Loader color="text-frescoWhite" ratio="w-6 h-6" />
                    <p class="text-sm sm:text-base ">Creating...</p>
                  </div>
                ) : (
                  <>
                    <DoubleStar />
                    <p class="text-sm sm:text-base ml-0.5">
                      {isMobile() ? "Create" : "Create Room with AI"}
                    </p>
                  </>
                )}
              </div>
            </button>
          </div>
          <div className="flex flex-col justify-center text-center space-y-2 pt-4">
            <p className="text-darkGray text-sm sm:text-base font-normal flex justify-center">
              Start your &nbsp;
              <span
                className="text-primary cursor-pointer contents"
                onClick={handleCreateRoom}
              >
                video room from scratch
              </span>
              &nbsp; or get an &nbsp;
              <span
                className="text-primary cursor-pointer contents sm:flex align-center"
                onClick={copyInstantCallLink}
              >
                instant call link
                {isInstanceCall === "copy" && (
                  <span className="inline-flex ml-2 mt-0.5">
                    <Loader ratio="h-5 w-5" />
                  </span>
                )}
              </span>
            </p>
          </div>
        </div>
      </div>
      {auth?.user && roomUUID ? (
        <CreatedLinkModal
          isOpen={!!roomUUID}
          setIsOpen={(flag) => !flag && setRoomUUID(undefined)}
          roomCode={roomUUID}
        />
      ) : undefined}
      {auth?.user && <CreateRoom isOpen={isOpen} setIsOpen={setIsOpen} />}
      <ConfirmationModal
        title="Upgrade to Premium"
        text={"You have reached your limit of adding Rooms."}
        description="Upgrade to premium to add more Rooms."
        openModal={openConfirmationModal}
        setOpenModal={setOpenConfirmationModal}
        primaryButtonText="Upgrade"
        primaryAction={() => {
          setOpenConfirmationModal(false);
          openPlanModal(dispatch);
        }}
        secondaryButtonText={"Cancel"}
        secondaryAction={() => {
          setOpenConfirmationModal(false);
        }}
        showLearnMore={true}
      />
    </>
  );
};

export default HomeHeader;
